import * as yup from "yup";

export const schemaUpdateUser = ({ changePassword = false } = {}) =>
  yup.object({
    name: yup.string().required("El nombre es obligatorio"),
    apellido: yup.string().required("El apellido es obligatorio"),
    email: yup
      .string()
      .email("Ingrese un correo electrónico válido")
      .required("El correo electrónico es obligatorio"),
    documento: yup
      .string()
      .matches(/^\d+$/, "El documento solo debe contener números")
      .required("El documento es obligatorio"),
    role_id: yup.string().required("Debe seleccionar un rol"),
    status: yup.string().required("Debe seleccionar un estado"),
    instituciones: yup.array().when("role_id", {
      is: (role_id) => {
        const n = Number(role_id);
        return n === 2 || n === 3;
      },
      then: (schema) => schema.min(1, "Debe seleccionar al menos una institución"),
      otherwise: (schema) => schema.notRequired(),
    }),
    licencias: yup.array().min(1, "Debe seleccionar al menos una institución"),
    password: changePassword
      ? yup.string().required("La contraseña es obligatoria")
      : yup.string().notRequired(),
    password_confirm: changePassword
      ? yup
          .string()
          .required("Debe repetir la contraseña")
          .oneOf([yup.ref("password")], "Las contraseñas no coinciden")
      : yup.string().notRequired(),
  });
// export const schemaUpdateUser = yup.object().shape({
//     name: yup.string().required("El nombre es obligatorio"),
//     apellido: yup.string().required("El apellido es obligatorio"),
//   })


    //   domicilio: yup.string().required("El domicilio es obligatorio"),
    //   telefono: yup
    //     .string()
    //     .matches(/^\d+$/, "El teléfono solo debe contener números")
    //     .required("El teléfono es obligatorio"),
